import React, { useEffect, useState, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SubBanner from "../../components/SubBanner";
import bannerImg from "../../assets/img/terms_banner.png";
import { TERMS_DETAIL_URL } from "../../utils/urls";
import instance from "../../services/services";

function Privacy() {
  const navigate = useNavigate();
  const { type } = useParams();
  const [activeTab, setActiveTab] = useState(1);
  const [termsTab, setTermsTab] = useState(0);
  const [termsDetail, setTermsDetail] = useState(null);
  
  const tabList = [
    { label: "이용약관", url: "/terms/acetrader" },
    { label: "개인정보 처리방침", url: "/privacy" },
    { label: "맞춤형 광고안내", url: "/customizedAd" },
  ];

  const termsList = useMemo(() => [
    {
      id: "acetrader",
      label: "ACE Trader 개인정보처리방침",
      page_kind: "1",
    },
    {
      id: "acexchange",
      label: "ACE eXchange 개인정보처리방침",
      page_kind: "2",
    },
    {
      id: "adlib",
      label: "ACE ADLIB 개인정보처리방침",
      page_kind: "3",
    },
  ], []);

  useEffect(() => {
    const foundIndex = termsList.findIndex((term) => term.id === type);
    if (foundIndex !== -1) {
      setTermsTab(foundIndex);
    } else {
      navigate("/privacy/acetrader", { replace: true });
    }
  }, [type, navigate, termsList]);

  const handleTabClick = (id, idx) => {
    setTermsTab(idx);
    navigate(`/privacy/${id}`);
  };

  // 개인정보처리방침 상세 정보 가져오기
  const fetchTermsDetail = async (pageKind) => {
    try {
      const response = await instance.post(TERMS_DETAIL_URL, {
        terms_type: "privacy",
        page_kind: pageKind
      });
      setTermsDetail(response.data.data.contents);
    } catch (error) {
      console.error('개인정보처리방침 상세 정보 가져오기 오류:', error);
      setTermsDetail(null);
    }
  };

  // termsTab이 변경될 때마다 개인정보처리방침 상세 정보 가져오기
  useEffect(() => {
    if (termsTab >= 0 && termsList[termsTab]) {
      fetchTermsDetail(termsList[termsTab].page_kind);
    }
  }, [termsTab, termsList]);

  return (
    <div className="terms">
      <SubBanner
        bgImg={bannerImg}
        title={"NHN ACE 이용약관 및 개인정보처리방침"}
        tabs={tabList.map((tab, idx) => ({
          label: tab.label,
          url: tab.url,
          active: activeTab === idx,
          onClick: () => setActiveTab(idx),
        }))}
        location={[
          { label: "이용약관 및 개인정보처리방침", url: "/privacy/acetrader", active: true },
        ]}
      />

      <div className="terms_section mt-[140px] md:mt-[210px] mb-[40px] mx-auto">
        <ul className="tab_list">
          {termsList.map((term, idx) => (
            <li
              key={term.id}
              className={termsTab === idx ? "active" : ""}
              onClick={() => handleTabClick(term.id, idx)}
            >
              {term.label}
            </li>
          ))}
        </ul>
      </div>

      <div className="terms_section mb-[120px] mx-auto whitespace-pre-line">
        {termsDetail ? (
          <div dangerouslySetInnerHTML={{ __html: termsDetail }} />
        ) : (
          <div>데이터가 없습니다.</div>
        )}
      </div>
    </div>
  );
}

export default Privacy;
